var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPresentersUnfilled = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47469_108982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99997 1.5C3.61926 1.5 2.49997 2.61929 2.49997 4C2.49997 5.38071 3.61926 6.5 4.99997 6.5C6.38068 6.5 7.49997 5.38071 7.49997 4C7.49997 2.61929 6.38068 1.5 4.99997 1.5Z",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 7.5C2.33696 7.5 1.70107 7.76339 1.23223 8.23223C0.763392 8.70107 0.5 9.33696 0.5 10V11C0.5 11.2761 0.723858 11.5 1 11.5H9C9.27614 11.5 9.5 11.2761 9.5 11V10C9.5 9.33696 9.23661 8.70107 8.76777 8.23223C8.29893 7.76339 7.66304 7.5 7 7.5H3Z",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0159 7.93994C10.0849 7.67257 10.3576 7.51178 10.625 7.58082C11.1613 7.7193 11.6365 8.03198 11.9759 8.46976C12.3152 8.90755 12.4996 9.44565 12.5 9.99957L12.5 10.9999C12.5 11.2761 12.2761 11.4999 12 11.4999C11.7239 11.4999 11.5 11.2761 11.5 10.9999V10.0001C11.4997 9.66782 11.3891 9.34505 11.1855 9.08243C10.9819 8.81976 10.6968 8.63215 10.375 8.54906C10.1076 8.48003 9.94684 8.20731 10.0159 7.93994Z",
    fill: "#E5E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62405 1.58056C8.35654 1.51207 8.08415 1.67341 8.01565 1.94092C7.94716 2.20843 8.1085 2.48082 8.37601 2.54931C8.69866 2.63193 8.98465 2.81958 9.18887 3.08268C9.3931 3.34578 9.50395 3.66938 9.50395 4.00244C9.50395 4.3355 9.3931 4.65909 9.18887 4.9222C8.98465 5.1853 8.69866 5.37295 8.37601 5.45556C8.1085 5.52406 7.94716 5.79645 8.01565 6.06396C8.08415 6.33147 8.35654 6.49281 8.62405 6.42431C9.16181 6.28663 9.63845 5.97388 9.97882 5.53537C10.3192 5.09686 10.504 4.55755 10.504 4.00244C10.504 3.44733 10.3192 2.90801 9.97882 2.46951C9.63845 2.031 9.16181 1.71825 8.62405 1.58056Z",
    fill: "#E5E4EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47469_108982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPresentersUnfilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-presenters-unfilled.0a609b88d6a10b04708930eac016bfcc.svg";